<template>
  <div class="command-system">
    <div id="GraphContainer" style="display: none" ref="GraphContainer"></div>
    <div class="command-tree-panel">
      <vue2-org-tree style="display: flex;justify-content: center;min-height: 600px;;"  :data="treeData[0]" @on-node-click="handleClick" ref="org-tree" />
    </div>

    <dialog-reset
      slotShow
      height="25vh"
      top="25vh"
      width="40%"
        :title="treeMemo.activeNode.label ? `当前节点：<${treeMemo.activeNode.label}>` : '新增执行'   "
      :visible.sync="optBarVisible"
    >
      <el-row>
        <el-button type="primary" @click="command('addChild')" >新增子节点</el-button>
        <el-button type="success" @click="command('editNode')">编辑节点</el-button>
        <el-button type="success" @click="command('deleteNode')">删除此节点</el-button>
      </el-row>
      <div></div>
    </dialog-reset>

    <dialog-reset
      slotShow
      height="45vh"
      top="5vh"
      width="50%"
    title="新增执行"
      :visible.sync="formVisible"
    >
      <ConfigureStructure
        :key="formKey"
        ref="formComponen"
        :form-data="editingForm"
        @handleClose="handleClose"
      />

      <span slot="dialog_footer">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="submit"
          >提 交</el-button
        >
      </span>
    </dialog-reset>
  </div>
</template>

<script>
import x6Mixin from "./x6Mixin.js";
import ConfigureStructure from "./third-layer-form/configure-structure.vue";
export default {
  mixins: [x6Mixin],
  props: {
    activeName: "",
    info:{
      type:Object,
      default:()=>{}
    }
  },
  components: {
    ConfigureStructure,
  },
  watch: {
    activeName(newVal) {
      if (newVal === "t2") {
        this.initX6();
      }
    },
  },
  data() {
    return {
        commandSige:'',
      defaultProps: {
        children: 'children',
        label: 'label',
        value: 'value'
      },
      TheOneItem:{
        organizationName: "子指挥体系名称",
        responsiblePersonId: 1234567891,
        responsiblePersonName: "子负责人姓名",
        responsiblePersonContact: "联系电话",
        mainDuties: "子主要职责",
        label: "总中心",
        value: "-1",
        children: []
      },
      optBarVisible: false,
      treeMemo:{
        activeNode:{
            label:'',
            value:'',
            children:[]
        },
      },
      treeData: [{
        label: "总中心",
        value: "-1",
        id:'-1',
        organizationName: "指挥体系名称",
        responsiblePersonId: 1234567890,
        responsiblePersonName: "负责人姓名",
        responsiblePersonContact: "联系电话",
        mainDuties: "主要职责",
        children: []
      }],
      formVisible: false,
      formKey: 0,
      editingForm: {},
      x6Data: [],
      metaOne: {
        id: "",
        planId: "",
        planVersion: 1,
        parentId: 0,
        organizationName: "",
        responsiblePersonId: 1234567890,
        responsiblePersonName: "负责人姓名",
        responsiblePersonContact: "联系电话",
        mainDuties: "主要职责",
        commandRole: "指挥角色",
        children: [],
      },
    };
  },
  mounted () {
    if (this.info && Array.isArray(this.info.children)) {
      this.info.children.forEach(item => {
        this.treeData[0].children.push({
          ...item,
          label: item.organizationName,
          value: item.organizationName
        })
      })
    }
  },
  methods: {
    addNode(parentNodeId,data) {
    const newNode = { 
        ...data,
    };
    const findNode = (nodes, parentId) => {
      for (let node of nodes) {
        if (node.id === parentId) {
          if (!node.children) {
            this.$set(node, 'children', []); // 使用Vue.set确保响应性
          }
          node.children.push(newNode);
          return true;
        } else if (node.children) {
          if (findNode(node.children, parentId)) {
            return true;
          }
        }
      }
      return false;
    };
    findNode(this.treeData, parentNodeId);
  },
  removeNode(nodeId) {
    const removeFromArray = (arr, id) => {
      const index = arr.findIndex(node => node.id === id);
      if (index !== -1) {
        arr.splice(index, 1); // 移除元素并返回true，否则返回false
        return true;
      } else {
        for (let node of arr) {
          if (node.children && removeFromArray(node.children, id)) {
            if (node.children.length === 0) { // 如果子节点被删除完，可以移除children属性以节省空间（可选）
              delete node.children; // 使用Vue.delete确保响应性删除属性
            }
            return true; // 子节点找到并删除成功，返回true表示已处理
          }
        }
      }
      return false; // 未找到指定ID的节点，返回false表示未处理
    };
    removeFromArray(this.treeData, nodeId); // 从根节点开始搜索并尝试删除指定ID的节点
  },

    findSolid(node,index){
        console.log('node',node.label)
        if(node && node.children && node.children[index]){
            // 如果有子节点就返回
            console.log(`-------`,node.children[index].label)
            return node.children[index]
        }else{
            return false;
        }
    },
    findNode(nodeId) {
      // 递归查找树结构中的节点
      const searchNode = (nodes, targetId) => {
        for (let node of nodes) {
          if (node.id === targetId) {
            return node;
          }
          if (node.children && node.children.length > 0) {
            const found = searchNode(node.children, targetId);
            if (found) {
              return found;
            }
          }
        }
        return null;
      };
      return searchNode(this.treeData, nodeId);
    },
    command(sige){
        // const or = this.treeMemo.activeNode.order
        // let node = this.treeData;
        // for(let i = 0; i < or.length - 1; i++){
        //     const au =  this.findSolid(node,or[i])
        //     if(au){
        //         node = au
        //     }
        // }
        const node = this.treeMemo.activeNode
        this.commandSige = sige
        switch(sige){
            case 'addChild':
                    this.optBarVisible = false
                    this.openNodeForm({})
                // this.addNode(node.id)
                // this.addChild(node)
                break
            case 'deleteNode':
                this.removeNode(node.id)
                // this.deleteNode(node)
                break
            case 'editNode':
                // this.editNode(node)
                this.optBarVisible = false
                this.openNodeForm(this.findNode(node.id) || node)
                break
            default:
                break
        }
    },
    getFormData(node = {}) {
      return {
        ...node,
        responsiblePersonPhone: node.responsiblePersonPhone || node.responsiblePersonContact || '',
        responsibility: node.responsibility || node.mainDuties || ''
      }
    },
    openNodeForm(data) {
      this.editingForm = this.getFormData(data)
      this.formKey += 1
      this.formVisible = true
    },
    buildNodeParams(data) {
      return {
        ...data,
        responsiblePersonContact: data.responsiblePersonPhone || data.responsiblePersonContact || '',
        mainDuties: data.responsibility || data.mainDuties || '',
        label: data.organizationName,
        value: data.id,
        id: new Date().getTime()
      }
    },

    handleClick(Event,data) {
        this.treeMemo.activeNode = data
      this.optBarVisible = true;
      console.log(data);
    },
    handleClose() {},
    submit() {
        // 新增一个节点
      const data = this.$refs.formComponen.submit();
      const params = this.buildNodeParams(data)
      if(this.commandSige === 'addChild'){
      this.addNode(this.treeMemo.activeNode.id,params)
      this.formVisible = false;
      }
      if(this.commandSige === 'editNode'){
        // 如果当前是编辑当前的节点
        const node = this.findNode(this.treeMemo.activeNode.id)
        node.organizationName = params.organizationName
        node.responsiblePersonId = params.responsiblePersonId
        node.responsiblePersonName = params.responsiblePersonName
        node.responsiblePersonPhone = params.responsiblePersonPhone
        node.responsiblePersonContact = params.responsiblePersonPhone || params.responsiblePersonContact
        node.responsibility = params.responsibility
        node.mainDuties = params.responsibility || params.mainDuties
        node.commandRole = params.commandRole
        if (params.children) {
          node.children = params.children
        }
        node.label = params.organizationName
        this.formVisible = false;
        this.commandSige = ''
    
      }
    },
    echoData() {
      return this.treeData
    },
  },
};
</script>

<style scoped lang="scss">
p {
  margin: 0;
}
.command-system {
  min-height: 520px;
  padding: 18px 20px;
  background: #fff;
  border: 1px solid #e6edf6;
  border-radius: 8px;
  box-shadow: 0 3px 12px rgba(31, 45, 61, 0.04);
}
.command-tree-panel {
  min-height: 500px;
  padding: 22px 16px;
  background:
    linear-gradient(#f7faff 1px, transparent 1px),
    linear-gradient(90deg, #f7faff 1px, transparent 1px);
  background-size: 28px 28px;
  border: 1px dashed #d7e3f3;
  border-radius: 8px;
}
::v-deep .org-tree-node-label .org-tree-node-label-inner {
  padding: 10px 18px;
  color: #334155;
  border: 1px solid #dbe7f6;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(31, 45, 61, 0.08);
}
#GraphContainer {
  width: 800px;
  height: 600px;
  min-height: 400px;
  min-width: 500px;
}
</style>
